<template>
<div class="container-fluid">
	<div class="row">
	    <div class="col-12">
			<h1>Account Settings</h1>
		</div>
	</div>

	<form @submit.prevent="submitForm" @keydown="form.onKeydown($event)" @change="form.onKeydown($event)" class="mb-0">
		<alert-errors :form="form">There were some problems with your input.</alert-errors>
		<alert-errors :form="pw_form">There were some problems with your input.</alert-errors>

		<div class="row">
			<div class="col">
				<div class="card">
					<div class="d-flex" style="min-height:400px">

						<div class="card-side-menu bg-gray-100 rounded-left" style="min-width:150px;">
							<div class="card-header bg-gray-600 text-white" style="border-top-right-radius: 0px; border-bottom:1px solid #6c757d;">Settings</div>
							<div class="flex-column p-2">
								<span class="btn-block btn btn-ghost-primary text-left px-25 leading-tight" :class="{'active' : active_panel == 'profile'}" @click="setPanel('profile')" data-test="selectProfileTab">Profile</span>
								<span class="btn-block btn btn-ghost-primary text-left px-25 leading-tight" :class="{'active' : active_panel == 'password'}" @click="setPanel('password')" data-test="selectPasswordTab">Password</span>
								<span class="btn-block btn btn-ghost-primary text-left px-25 leading-tight" :class="{'active' : active_panel == 'groups'}" @click="setPanel('groups')" data-test="selectGroupsTab">Groups</span>
								<span class="btn-block btn btn-ghost-primary text-left px-25 leading-tight" :class="{'active' : active_panel == 'subscriptions'}" @click="setPanel('subscriptions')" data-test="selectSubscriptionsTab">Subscriptions</span>
								<span class="btn-block btn btn-ghost-primary text-left px-25 leading-tight" :class="{'active' : active_panel == 'locations'}" @click="setPanel('locations')" data-test="selectLocationsTab">Locations</span>
								<span class="btn-block btn btn-ghost-primary text-left px-25 leading-tight" :class="{'active' : active_panel == 'roles'}" @click="setPanel('roles')" v-if="perms.can_do_everything" data-test="selectRolesTab">Roles</span>
							</div>
						</div>

						<div v-show="active_panel == 'profile'" :class="{'pending' : pending }" class="content-panel flex-grow-1">
							<div class="card-header">Profile</div>
							<div class="card-body row">
								<div class="col-md-auto" style="max-width: 200px">
									<file-field
										ref="image"
										:default_url="user.photo_url"
										@file_changed="changedImage($event)"
									/>
							    </div>
								<div class="col">				
								    <div class="form-group">
										<label class="mb-0">First Name</label>
										<input class="form-control" v-model="form.first_name" required data-test="userFirstName">
								    </div>
								    <div class="form-group">
										<label class="mb-0">Last Name</label>
										<input class="form-control" v-model="form.last_name" required data-test="userLastName">
								    </div>
								    
								    <div class="form-group">
									    <label class="mb-0">Email</label>
									    <input class="form-control" v-model="form.email" type="email" autocomplete="off" data-lpignore="true" :disabled="!perms.can_do_everything">
									    <div class="form-text text-sm text-gray-500 leading-tight">Contact your account manager to change email</div>
								    </div>							    
								</div>
								<div class="col-12 text-right">
									<button type="submit" class="btn btn-primary" :disabled="!form.first_name || !form.last_name" data-test="saveUserProfileButton">Save Profile</button>
								</div>									
							</div>
						</div>

						<div v-show="active_panel == 'password'" :class="{'pending' : pending }" class="content-panel flex-grow-1">
							<div class="card-header">Password</div>
							<div class="card-body">
								<div class="form-group">
									<label class="mb-0">New Password</label>
									<input class="form-control w-auto" v-model="pw_form.password" type="password" autocomplete="new-password" data-lpignore="true" data-test="userPassword">
									<password-reqs 										
										:password="pw_form.password"
										:requirements="user.password_reqs" 
										@pw_checks_changed="changedPwChecks($event)" />
							    </div>	
								<div class="form-group pb-1">
									<label class="mb-0">Confirm</label>
									<input class="form-control w-auto" v-model="pw_form.password_confirmation" type="password" autocomplete="new-password" data-lpignore="true" data-test="userPasswordConfirm">
									<div class="form-text text-base text-gray-600 mb-0">
										<i :class="pw_form.password != null && pw_form.password == pw_form.password_confirmation ? 'fal fa-check text-green-500' : 'fal fa-long-arrow-right'"></i>
										Passwords match
									</div>									
							    </div>
								<div class="text-right">
									<span class="btn btn-primary"
										:class="{ 'disabled' : disablePasswordSubmit }"
										@click="disablePasswordSubmit ? '' : submitPassword()"
										data-test="saveUserPasswordButton">Save Password
									</span>
								</div>
							</div>
						</div>

						<div v-show="active_panel == 'groups'" :class="{'pending' : pending }" class="content-panel flex-grow-1">
							<div class="card-header">Groups</div>
							<div class="card-body">
								<div v-if="user.org_id" class="form-group">
									<div class="text-blue-700 font-weight-bold pb-1">Organization</div>
									{{ user.org.name }} <span v-if="user.roles.some(role => role.name == 'org admin')" class="badge text-blue-700 bg-blue-100">org admin</span>
									<div class="mt-3 mb-3" style="border-top:1px solid #e4e7ea;margin-left:-20px; margin-right:-20px;"></div>
								</div>

								<div v-if="user.multi_client" class="form-group">
									<div class="text-blue-700 font-weight-bold pb-1">Default Client</div>
									<v-select
										label="name"
										:options="[{id: null, name: 'None (remember last login)'}, ...client_list]"
										:reduce="name => name.id"
										v-model="form.default_client"
										data-test="userDefaultClient"
									/>
									<div class="form-text text-sm text-gray-500 leading-tight">Select a default client when logging in. Contact your account manager to add new clients.</div>
									<div class="mt-3 mb-3" style="border-top:1px solid #e4e7ea;margin-left:-20px; margin-right:-20px;"></div>
								</div>

						    	<div v-if="user.roles.some(role => role.name == 'org admin')" class="row">
							    	<div class="col-12">
								    	<div class="rounded bg-yellow-100 text-yellow-700 text-sm p-25 mb-25 font-weight-bold leading-tight">
									    	As an org admin, you have admin-level access to all clients in the organization. Your user is not visible to a client unless explicitly assigned.
									    </div>
								    </div>

								    <div class="col-md col-sm-12 mb-35">
										<div class="text-blue-700 font-weight-bold pb-1">Assigned Clients</div>
									    <div v-for="client in client_list" class="form-check">
									    	<input type="checkbox" class="form-check-input" :value="client.id" v-model="form.client_list">
									    	<label class="form-check-label">{{ client.name }}</label>
										</div>
									</div>

								    <div class="col-md col-sm-12" v-if="!perms.can_do_everything">
									    <div class="text-blue-700 font-weight-bold pb-1">Org Clients</div>
										<ul class="pl-35 text-gray-700">
											<li v-for="client in client_list">
												{{ client.name }}
											</li>
										</ul>
									</div>									
								</div>

							    <div v-else class="form-group" data-test="userClientList">
									<div class="text-blue-700 font-weight-bold pb-1">Your Clients</div>
								    <template v-if="perms.can_do_everything">
									    <div v-for="client in client_list" class="form-check">
									    	<input type="checkbox" class="form-check-input" :value="client.id" v-model="form.client_list">
									    	<label class="form-check-label">{{ client.name }}</label>
										</div>
									</template>
									<template v-else>
										<ul class="pl-35 text-gray-700 mb-0">
											<li v-for="client in client_list">
												{{ client.name }}
											</li>
										</ul>	
										<div class="form-text text-sm text-gray-500 leading-tight">Contact an admin or your account manager to change clients</div>
									</template>	
								</div>

								<div class="text-right">
									<button type="submit" class="btn btn-primary" data-test="saveUserGroupsButton">Save Groups</button>
								</div>									
							</div>
						</div>

						<div v-show="active_panel == 'subscriptions'" :class="{'pending' : pending }" class="content-panel flex-grow-1">
							<div class="card-header">Subscriptions</div>
							<div class="card-body">
								<div class="text-blue-700 font-weight-bold pb-1">Client Snapshot<br><span class="text-gray-500 font-weight-normal">A glance of activity at all of your facilties in the past week. Delivered Monday morning.</span></div>
								<div class="form-check">
									<input type="checkbox" class="form-check-input" v-model="client_snapshot" data-test="userClientSnapshot">
									<label class="form-check-label">Subscribed</label>
								</div>

								<div class="mt-3 mb-3" style="border-top:1px solid #e4e7ea;margin-left:-20px; margin-right:-20px;"></div>

							    <div class="text-blue-700 font-weight-bold pb-1">Weekly Digest<br><span class="text-gray-500 font-weight-normal">An overview of team check-ins for the prior week. Delivered Monday morning.</span></div>								    

							    <div v-for="client in client_list" class="form-check" data-test="userWeeklyDigest">
									<input type="checkbox" class="form-check-input" :value="client.id" v-model="subscriptions.weekly_digest">
							    	<label class="form-check-label">{{ client.name }}</label>
							    </div>
								<div class="text-right">
									<span class="btn btn-primary" @click="submitSubscriptions()" data-test="saveUserSubscriptionsButton">Save Subscriptions</span>
								</div>
							</div>
						</div>

						<div v-show="active_panel == 'locations'" :class="{'pending' : pending }" class="user-locations content-panel flex-grow-1">
				            <locations-manager
				            	:can_update_locations="true"
				                :locationable_id="user.id"
				                locationable_type="User"
				                :locations="user.locations"
				            >
				            	<template v-if="user.locations" v-slot:alert>
									<div class="rounded bg-yellow-100 text-yellow-800 text-sm p-25 mx-35 mt-25 leading-tight">
										Editing an existing location will <b>not</b> change past or current routes.
									</div>
				            	</template>
				            	<template v-else v-slot:alert>
									<div class="rounded bg-yellow-100 text-yellow-800 text-sm p-25 mx-35 mt-25 leading-tight">
										Locations saved here can be used in routes.
									</div>
				            	</template>
				            </locations-manager>
						</div>

						<div v-if="perms.can_do_everything" v-show="active_panel == 'roles'" class="user-locations flex-grow-1">		
							<div class="card-header">Roles</div>
							<div class="card-body">						
							 	<div class="form-group mb-0">
									<label class="text-gray-500">Assign roles carefully!</label>

									<div v-for="role in all_roles" class="form-check">
										<input type="checkbox" class="form-check-input" :value="role.id" v-model="form.user_roles">
										<label class="form-check-label">{{ role.name }}</label>
									</div>			    
							    </div>
								<div class="text-right">
									<button type="submit" class="btn btn-primary">Save Roles</button>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>


		<div class="row">
			<div class="col-12">
			    <div class="form-group">
			    	<span class="btn btn-ghost-secondary mr-1" @click="cancelEdit()">Cancel</span>
				</div>
			</div>

		</div>
	</form>


</div>
</template>

<script>
	//USER EDITING THEMSELF

	import { mapGetters, mapState } from 'vuex';
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
	import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';
	import { objectToFormData } from 'object-to-formdata';
	import LocationsManager from '../../components/LocationsManager';
	import PasswordReqs from '../../components/PasswordReqs';

	export default {
		mixins: [BreadcrumbsManager],

    	components: {
            HasError,
            AlertError,
            AlertErrors,
            AlertSuccess,
            Form,
            LocationsManager,
            PasswordReqs
    	},

		props: {
			id: {
				type: Number,
				required: true,
			},
		},

		data() {
			return {
				pending: false,
				active_panel: 'profile',
                form: {},
                pw_form: {},
                all_roles: null,

                client_snapshot: null,

                subscriptions: {
                	weekly_digest: [],
                	client_snapshot: [],
                },

                pw_checks: {},
			}
		},

		created() {
			this.fillForm(this.user);
			this.fetchSubscriptions();
			this.fetchRoles();
		},

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Account Settings', to: { name: 'users.edit'} },
            ]); 
        },

		methods: {
			cancelEdit() {
				this.$router.go(-1);
			},

			changedImage($event) {
                this.form.image = this.$refs.image.file;
            },

            changedPwChecks($event) {
            	this.pw_checks = $event;
            },

            fetchRoles() {
            	if (this.perms.can_do_everything) {
					axios.get('/api/roles/available').then(({data}) => {
						this.all_roles = data;
					});
				}
            },

            fetchSubscriptions() {
            	axios.get('/api/subscriptions/user/' + this.$route.params.id).then(({data}) => {
            		this.setSubscriptions(data);
	        	});
            },

            fillForm(userData) {
				this.form = new Form({
					first_name: userData.first_name,
					last_name: userData.last_name,
					email: userData.email,
					image: userData.image,
					default_client: userData.default_client_id,
				});

				this.pw_form = new Form({
					password: null,
					password_confirmation: null,
				});

				if (this.perms.can_do_everything) {					
					this.form.user_roles = userData.roles.map(role => role.id);
				}

				if (this.perms.can_assign_user_client) {
					this.form.client_list = userData.client_list_all.map(client => client.id);
				}
            },

            setPanel(value) {
            	this.active_panel = value;
            },

            setSubscriptions(data) {
            	this.client_snapshot = data.filter(sub => sub.subscribed_to == 'client_snapshot' && sub.status == 1).length;
            	this.subscriptions.weekly_digest = data.filter(sub => sub.subscribed_to == 'weekly_digest' && sub.status == 1).map(sub => sub.client_id);
            },

        	submitForm() { 
            	this.pending = true;

                this.form.submit('post', '/api/admin/users/' + this.$route.params.id, {
					transformRequest: [function (data, headers) {
						data['_method'] = 'PUT';
						return objectToFormData(data)
					}],
                }).then(({ data }) => {
					Swal.fire({
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 4000,
						icon: 'success',
						title: 'User saved',
					});

					this.$store.commit('setUser', data);
					this.pending = false;
            	}).catch((error) => { 
            		this.pending = false;
            	});
        	},

        	submitPassword() {
            	this.pending = true;

                this.pw_form.post('/api/admin/users/update-password').then(({ data }) => {
					Swal.fire({
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 4000,
						icon: 'success',
						title: 'Password changed',
					});
					this.pending = false;
            	}).catch((error) => { 
            		this.pending = false;
            	});
        	},

        	submitSubscriptions() {
        		this.pending = true;
        		axios.post('/api/subscriptions/user/' + this.$route.params.id, { subscriptions: this.subscriptions }).then(({data}) => {
					Swal.fire({
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 4000,
						icon: 'success',
						title: 'Subscriptions saved',
					});        			
        			this.setSubscriptions(data);
        			this.pending = false;
        		}).catch((error) => { 
            		this.pending = false;
            	});
        	}
		},

		computed: {
			...mapGetters(['client_list']),
			...mapState(['perms', 'user']),

			disablePasswordSubmit() {
				if (Object.values(this.pw_checks).includes(false) || !this.pw_form.password || this.pw_form.password != this.pw_form.password_confirmation) {
					return true;
				}
				return false;
			},
		},

		watch: {
			client_snapshot() {
				if (this.client_snapshot == true) {
					this.subscriptions.client_snapshot = [0];
				}
				else {
					this.subscriptions.client_snapshot.length = 0;
				}
			},
		}
	}
</script>

<style>
	.user-locations .card {
		box-shadow: none;
	}
</style>